namespace $ {

	export class $shm_hitalama_map_journal_recorder {

		private static geometry_events = new Map< string, $shm_hitalama_map_journal_snapshots_geometry_event[] >

		static journal( map: $shm_hitalama_map ) {
			return map.Journal_snapshots( null )?.ensure( map.land() )!
		}

		static geometry_events_for( map: $shm_hitalama_map ) {
			const key = map.link().str
			let events = this.geometry_events.get( key )
			if( !events ) {
				events = []
				this.geometry_events.set( key, events )
			}
			return events
		}

		@ $mol_action
		static clear( map: $shm_hitalama_map ) {
			this.geometry_events.set( map.link().str, [] )
		}

		@ $mol_action
		static event_add(
			map: $shm_hitalama_map,
			widget: $shm_hitalama_map_widget,
			data: {
				body_x: number
				body_y: number
				right_edge_x: number
				bottom_edge_y: number
			},
			recalculation: 'read' | 'write',
		) {
			this.geometry_events_for( map ).push({
				type: 'geometry',
				widget: widget.link_str(),
				local_time: Date.now(),
				time: 0,
				recalculation,
				geometry: {
					body_x: data.body_x,
					body_y: data.body_y,
					right_edge_x: data.right_edge_x,
					bottom_edge_y: data.bottom_edge_y,
				},
			})
			this.snapshot_write_if_requested( map )
		}

		@ $mol_action
		static snapshot_write_if_requested( map: $shm_hitalama_map ) {
			const journal = map.Journal_snapshots()?.remote()
			if( !journal ) return

			journal.write_if_requested( ( offset, client, run )=> {
				const events = this.geometry_events_for( map ).map( event => ({
					... event,
					time: event.local_time + offset,
				}) )
				return {
					run,
					client,
					client_info: journal.client_info( client ) ?? journal.client_info_make( client ),
					time_offset: offset,
					written_at: Date.now() + offset,
					events,
				}
			} )
		}

	}

}
